import { createReducer } from "redux-act";

import {
  // --------------EasyInest-----------------
  REQAnalyticList,
  RESAnalyticList,
  FailAnalyticList,
  CleanUpAnalyticList,
  // --------------UntHld-----------------
  REQAnalyticUntHldList,
  RESAnalyticUntHldList,
  FailAnalyticUntHldList,
  CleanUpAnalyticUntHldList,
  // --------------PVD-----------------
  REQAnalyticPVDList,
  RESAnalyticPVDList,
  FailAnalyticPVDList,
  CleanUpAnalyticPVDList,
  // --------------PVD Excel Download-----------------
  REQAnalyticPVDExcelDownload,
  RESAnalyticPVDExcelDownload,
  FailAnalyticPVDExcelDownload
} from "./actions";

const initialState = {
  REQStrAnalyticList: false,
  AnalyticList: [],

  REQStrAnalyticUntHldList: false,
  AnalyticUntHldList: [],

  REQStrAnalyticPVDList: false,
  AnalyticPVDList: [],

  REQStrAnalyticPVDExcelDownload: false
};

const analyticListReducer = createReducer(
  {
    // --------------EasyInest-----------------
    [REQAnalyticList]: (state) => {
      return {
        ...state,
        REQStrAnalyticList: true
      };
    },

    [RESAnalyticList]: (state, payload) => {
      return {
        ...state,
        REQStrAnalyticList: false,
        AnalyticList: payload
      };
    },

    [FailAnalyticList]: (state) => {
      return {
        ...state,
        REQStrAnalyticList: false,
        AnalyticList: []
      };
    },
    [CleanUpAnalyticList]: () => {
      return initialState;
    },
    // --------------UntHld-----------------
    [REQAnalyticUntHldList]: (state) => {
      return {
        ...state,
        REQStrAnalyticUntHldList: true
      };
    },

    [RESAnalyticUntHldList]: (state, payload) => {
      return {
        ...state,
        REQStrAnalyticUntHldList: false,
        AnalyticUntHldList: payload
      };
    },

    [FailAnalyticUntHldList]: (state) => {
      return {
        ...state,
        REQStrAnalyticUntHldList: false,
        AnalyticUntHldList: []
      };
    },
    [CleanUpAnalyticUntHldList]: () => {
      return initialState;
    },
    // --------------PVD-----------------
    [REQAnalyticPVDList]: (state) => {
      return {
        ...state,
        REQStrAnalyticPVDList: true
      };
    },

    [RESAnalyticPVDList]: (state, payload) => {
      return {
        ...state,
        REQStrAnalyticPVDList: false,
        AnalyticPVDList: payload
      };
    },
    [FailAnalyticPVDList]: (state) => {
      return {
        ...state,
        REQStrAnalyticPVDList: false,
        AnalyticPVDList: []
      };
    },
    [CleanUpAnalyticPVDList]: () => {
      return initialState;
    },
    // --------------PVD Excel Download-----------------
    [REQAnalyticPVDExcelDownload]: (state) => {
      return {
        ...state,
        REQStrAnalyticPVDExcelDownload: true
      };
    },
    [RESAnalyticPVDExcelDownload]: (state) => {
      return {
        ...state,
        REQStrAnalyticPVDExcelDownload: false
      };
    },
    [FailAnalyticPVDExcelDownload]: (state) => {
      return {
        ...state,
        REQStrAnalyticPVDExcelDownload: false
      };
    }
  },

  initialState
);

export default analyticListReducer;